import AssetGraphs from "@hydrologiq/shared/asset/monitoring/AssetGraphs"
import { useParams } from "react-router-dom"
import { useAsset } from "../hooks/useAsset"
import { Skeleton, VStack } from "@chakra-ui/react"
import AssetHeadlineFigures from "./asset/AssetHeadlineFigures"
import { DateTime, utc } from "timezonecomplete"
import { useState } from "react"
import AssetTimescaleMonitoring from "./monitoring/AssetTimescaleMonitoring"

function AssetMonitoring() {
  const { assetId } = useParams()
  const { asset } = useAsset(assetId)

  const [refreshVersion, setRefreshVersion] = useState(0)

  const onRefresh = () => {
    setRefreshVersion(refreshVersion + 1)
  }

  // Guard: show skeleton until asset data (including source) is available
  // Only block on initial load — don't unmount during background refetches
  if (!asset) {
    return <Skeleton height="100%" width="100%" />
  }

  const source = asset.source // guaranteed non-null by backend coalescing
  const monitoredAssignments = 
    asset?.assignments?.all?.filter((assignment) => assignment.monitored)
  const latestAssignment = monitoredAssignments ? monitoredAssignments[0] : asset?.assignments?.all?.find((assignment) => assignment.id === asset?.assignments?.latest)
  const installation = latestAssignment?.installation?.id

  // When source is "timescale" (default after connection removal): render
  // server-driven Timescale monitoring. Historical data in TimescaleDB remains
  // available regardless of connection state.
  if (source === "timescale") {
    return <AssetTimescaleMonitoring asset={asset} />
  }

  // When source is "influx": render existing AssetGraphs (legacy) behaviour.
  // If no assignments are available but the asset has historical data, the
  // timescale path is used as a fallback so monitoring data remains visible
  // even after a data connection is removed.
  if (!asset.assignments?.all?.length) {
    return <AssetTimescaleMonitoring asset={asset} />
  }

  return (
    <VStack width="100%" gap={4} alignItems="stretch">
      <AssetHeadlineFigures
        asset={asset}
        stop={latestAssignment?.end ? new DateTime(latestAssignment.end, utc()) : undefined}
        refreshVersion={refreshVersion}
      />
      <AssetGraphs installation={undefined} key={installation} asset={asset} onRefresh={onRefresh} />
    </VStack>
  )
}

export default AssetMonitoring
